import React from 'react';
import AdminLayout from '../Admin/AdminLayout';
import ProductTable from './ProductTable';

const ProductsView = () => {
  const business = JSON.parse(localStorage.getItem('business'));
  const businessId = business?.id;

  const [reload, setReload] = React.useState(false);

  return (

      <div className="productos-page">
        <ProductTable key={reload} businessId={businessId} />
      </div>

  );
};

export default ProductsView;
